// The posting feed (postings.rs): the raw lines the service pushed to a stream,
// newest first, each carrying a verdict from being re-parsed on read.
//
// Polled while it is on screen. This is a troubleshooting view — someone
// restarts the service or fixes the POS path and watches for lines to start
// arriving — so a static snapshot would answer the wrong question. React Query
// stops the interval when the last observer unmounts, so leaving the tab
// stops the traffic.

import { useQuery } from "@tanstack/react-query";
import { http } from "./http";
import { postingKeys } from "./keys";
import type { PostingsResponse } from "./types";

export const POSTINGS_REFRESH_MS = 5_000;

/**
 * A screenful, not the server's maximum (which is 200).
 *
 * This is a panel on the location page, not a page of its own: a hundred rows
 * buried everything under it in a 4000px scroll. Enough to see traffic
 * arriving and which devices are reporting is enough — and it polls, so what
 * it shows stays current without being long.
 */
const PAGE_SIZE = 25;

export function usePostings(streamId: string) {
    return useQuery({
        queryKey: postingKeys.list(streamId),
        queryFn: () => http.get<PostingsResponse>(`/v1/streams/${streamId}/postings?limit=${PAGE_SIZE}`),
        refetchInterval: POSTINGS_REFRESH_MS,
        enabled: Boolean(streamId),
    });
}
